<main>
	<app-topnav></app-topnav>
	<section class="container maintenance" *ngIf="maintenance">
		<div><img src="assets/images/503.png" alt="MyClearAmber"></div>
		<h1>{{maintdata.title}}</h1>
		<h3>{{maintdata.message}}</h3>
	</section>
	<section class="container bulkmsg" *ngIf="!maintenance">
		<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#F38E2C" type = "ball-clip-rotate-pulse" [fullScreen] = "true"><p style="color: white" > Loading... </p></ngx-spinner>
		<div class="row">
			<div class="col-3">
				<mat-card class="leftbar">
					<mat-card-header>
						<mat-card-title>Bulk Uploads</mat-card-title>
					</mat-card-header>
					<mat-card-content>
						<div>
							<input id="file-id" type="file"(change)="upload($event)" style="display:none" />
		        			<label for="file-id" class="mat-focus-indicator md-button md-raised md-primary mat-raised-button mat-button-base upload">Upload Excel</label>
						</div>
						<mat-divider style="margin-top: 15px;"></mat-divider>
						<div style="margin-top: 15px;">
							<mat-list-item *ngFor="let bulk of bulks; let i = index" [ngClass]="{ 'active': i == 0 }">
						      <!-- <mat-icon matListItemIcon>note</mat-icon> -->
						      <div matListItemTitle>{{bulk.users.first_name}} - ({{bulk.count}})</div>
						      <div matListItemLine>{{bulk.timestamp | date :  "dd-MM-y h:mm a"}}</div>
						    </mat-list-item>
						</div>
					</mat-card-content>
				</mat-card>
			</div>
			<div class="col-3">
				<mat-card class="ordlist">
					<mat-card-header>
						<mat-card-title>Selected Orders ({{bulk?.count}})</mat-card-title>
					</mat-card-header>
					<mat-card-content>
						<div>
							<mat-list-item *ngFor="let order of bulk?.orders; let i = index">
						      <!-- <mat-icon matListItemIcon>note</mat-icon> -->
						      <div matListItemTitle>{{i+1}}. {{order.sale}}</div>
						      <div matListItemLine></div>
						    </mat-list-item>
						</div>
					</mat-card-content>
				</mat-card>
			</div>
			<div class="col-6">
				<mat-card class="msg">
					<mat-card-header>
						<mat-card-title>Message to send in all Chats</mat-card-title>
					</mat-card-header>
					<mat-card-content>
						<form>
							<mat-form-field class="w100">
								<mat-label>Bulk Message for all Uploaded orders:</mat-label>
								<textarea matInput placeholder="Bulk Message for all Uploaded orders..." [(ngModel)]="bulk.message" [ngModelOptions]="{standalone: true}" rows="22"></textarea>
							</mat-form-field>
							<div class="w100">
								<mat-slide-toggle [(ngModel)]="bulk.execute" [ngModelOptions]="{standalone: true}">Send Message</mat-slide-toggle>
								<mat-slide-toggle [(ngModel)]="bulk.notify" [ngModelOptions]="{standalone: true}">Notify Customer</mat-slide-toggle>
								<button mat-raised-button (click)="sendMessage()" style="float: right; top: -10px;">Send <mat-icon aria-hidden="false" aria-label="send icon">send</mat-icon></button>
							</div>
						</form>
					</mat-card-content>
				</mat-card>
			</div>
		</div>
	</section>
</main>